import React from "react";
import { motion, AnimatePresence } from "motion/react";
import { Wifi, Loader2, CheckCircle, RotateCcw } from "lucide-react";

export default function AutoSaveIndicator({
  autoSaving,
  lastAutoSaved,
  restoredFromDraft,
  onDismissRestore
}) {
  const timeLabel = lastAutoSaved
    ? lastAutoSaved.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" })
    : null;

  return (
    <div id="autosave-indicator_root" className="flex items-center gap-3">
      <AnimatePresence mode="wait">
        {restoredFromDraft && (
          <motion.div
            key="restored"
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -10 }}
            className="flex items-center gap-2"
          >
            <RotateCcw className="w-4 h-4 text-amber-400" />
            <span className="text-lg font-extralight text-amber-400">
              Восстановлено из черновика
            </span>
            {onDismissRestore && (
              <button
                onClick={onDismissRestore}
                className="text-lg font-extralight text-neutral-500 hover:text-neutral-300 transition-colors ml-1"
              >
                ОК
              </button>
            )}
          </motion.div>
        )}

        {!restoredFromDraft && autoSaving && (
          <motion.div
            key="saving"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="flex items-center gap-1.5 text-neutral-500"
          >
            <Loader2 className="w-3.5 h-3.5 animate-spin" />
            <span className="text-lg font-extralight">Сохранение...</span>
          </motion.div>
        )}

        {!restoredFromDraft && !autoSaving && timeLabel && (
          <motion.div
            key="saved"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="flex items-center gap-1.5 text-neutral-500"
          >
            <Wifi className="w-3.5 h-3.5 text-accent-500" />
            <span className="text-lg font-extralight">
              Автосохранение {timeLabel}
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
